// extracted by mini-css-extract-plugin
module.exports = {"locationCard":"styles_locationCard__jeRjB","btnsContainer":"styles_btnsContainer__fn_fk"};